import { render, staticRenderFns } from "./OtherConstructionCosts.vue?vue&type=template&id=19ed48e6&scoped=true"
import script from "./OtherConstructionCosts.vue?vue&type=script&lang=js"
export * from "./OtherConstructionCosts.vue?vue&type=script&lang=js"
import style0 from "./OtherConstructionCosts.vue?vue&type=style&index=0&id=19ed48e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed48e6",
  null
  
)

export default component.exports